"use strict";

{

    const uid = () => {
        return (Date.now().toString(36) + Math.random().toString(36).substring(2));
    };

    class QuickAdd {
        /** @type {HTMLDivElement} */
        constructor({ elem }) {

            this.uniq = uid();

            this.dom = {
                main: elem,
                trigger: elem.querySelector('.quick-add__open'),
                checkboxes: elem.querySelectorAll('.SizeSwatch__Checkbox'),
                labels: elem.querySelectorAll('.SizeSwatch__Label'),
                price: elem.querySelector('.quick-add__price [data-price]'),
                compareAtPrice: elem.querySelector('.quick-add__price [data-compare-at-price]'),
                quantitySelector: {
                    increase: elem.querySelector('.quick-add__quantitySelector [data-action="increase-quantity"]'),
                    decrease: elem.querySelector('.quick-add__quantitySelector [data-action="decrease-quantity"]'),
                    input: elem.querySelector('.quick-add__quantitySelector input')
                },
                submit: elem.querySelector('.quick-add__add-to-cart')
            }

            elem.classList.remove('js-quick-add');

            this.init();
        }

        init() {
            this.uniqify();
            this.addEventListeners();
            this.changeQuantity();
            this.submitClick();
        }


        uniqify() {

            this.dom.checkboxes.forEach((checkbox, index) => {
                const variantId = checkbox.getAttribute('data-variant-id');
                checkbox.setAttribute('name', this.uniq);
                checkbox.setAttribute('id', variantId + '-' + this.uniq);

                this.dom.labels[index].setAttribute('for', variantId + '-' + this.uniq);
            });

        }

        addEventListeners() {
            this.dom.trigger.addEventListener('click', () => {
                this.dom.main.classList.add('open')
            })

            this.dom.main.addEventListener('mouseleave', () => {
                const closeElem = () => {
                    this.dom.main.classList.remove('open')
                }
                const closingTimer = setTimeout(closeElem, 1000);
                this.dom.main.addEventListener('mouseenter', () => {
                    clearTimeout(closingTimer);
                });
            })

            this.dom.checkboxes.forEach(checkbox => {
                checkbox.addEventListener('click', () => {

                    this.dom.checkboxes.forEach(checkboxReset => {
                        checkboxReset.checked = false;
                    })

                    checkbox.checked = true;

                    this.changePrice(checkbox);
                })

            })
        }

        changePrice(checkbox) {
            const price = Number(checkbox.dataset.price);
            const compareAtPrice = Number(checkbox.dataset.compareAtPrice);
            this.updatePrice({ price: price, compareAtPrice: compareAtPrice });
        };


        updatePrice({ price = 0, compareAtPrice = 0 }) {
            this.dom.price.innerText = Shopify.formatMoney(price, window.theme.moneyFormat);

            if (compareAtPrice > price) {
                this.dom.price.classList.add('Price--highlight')
                this.dom.compareAtPrice.innerText = Shopify.formatMoney(compareAtPrice, window.theme.moneyFormat);
                this.dom.compareAtPrice.hidden = false;
            } else {
                this.dom.price.classList.remove('Price--highlight');
                this.dom.compareAtPrice.hidden = true;
            }
        }

        changeQuantity() {
            const min = 1;
            const max = 99;
            this.dom.quantitySelector.increase.addEventListener('click', () => {
                if (this.dom.quantitySelector.input.value < max) {
                    this.dom.quantitySelector.input.value = Number(this.dom.quantitySelector.input.value) + 1
                }
            })

            this.dom.quantitySelector.decrease.addEventListener('click', () => {
                if (this.dom.quantitySelector.input.value > min) {
                    this.dom.quantitySelector.input.value = Number(this.dom.quantitySelector.input.value) - 1
                }
            })
        }

        submitClick() {

            this.dom.submit.addEventListener('click', () => {

                const selectedVariant = [...this.dom.checkboxes].find(x => x.checked == true);
                if (!selectedVariant) return;

                const variantId = Number(selectedVariant.dataset.variantId)
                const quantity = Number(this.dom.quantitySelector.input.value);

                this.addToCart({ variantId: variantId, quantity: quantity });
            })
        }

        addToCart({ variantId, quantity }) {
            const formData = { items: [{ 'id': variantId, 'quantity': quantity }] };

            fetch('/cart/add.js', {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json().then(data => {
                        if (response.ok) {
                            document.dispatchEvent(new CustomEvent('product:added', {
                                bubbles: true,
                                detail: {
                                    data: data,
                                    variant: variantId,
                                    quantity: quantity
                                }
                            }));

                        } else {
                            this.errorHandler({ errorData: data });
                        }
                    })

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }

        errorHandler({ errorData }) {

            switch (errorData.status) {
                case 422: //Not enough inventory  
                    this.errorAlertMessage({ errorData });
                    break;
            }
        }

        errorAlertMessage({ errorData }) {
            setTimeout(() => {
                alert(errorData.description)
            }, 400);
        }
    }


    const initQuickAdd = () => {
        const quickAddElems = document.querySelectorAll('.js-quick-add');
        
        quickAddElems.forEach(quickAddElem => {
            void new QuickAdd({ elem: quickAddElem })
        });
    }

    initQuickAdd();

    document.addEventListener('Carousel:Build', () => {
        initQuickAdd();
    });
    document.addEventListener('filter:reloaded', () => {
        initQuickAdd();
    });

    document.addEventListener('theme:search:end', () => {
        initQuickAdd();
    });

    document.addEventListener('helloRetail:searched', () => {
        initQuickAdd();
    });


}